import { useSplit } from '@buffer-mono/features'

import { useAccountId } from '~publish/contexts/AccountContext'

export function useIsTemplateManager(): {
  canManage: boolean
  isReady: boolean
} {
  const accountId = useAccountId()

  const options = accountId
    ? { splitKey: accountId, trafficType: 'user' as const }
    : undefined

  const { split, isReady } = useSplit('post-template-manager', options)
  return {
    canManage: split.treatment === 'on',
    isReady,
  }
}
